import { render, staticRenderFns } from "./tableRoleMenu.vue?vue&type=template&id=181336db&scoped=true"
import script from "./tableRoleMenu.vue?vue&type=script&lang=js"
export * from "./tableRoleMenu.vue?vue&type=script&lang=js"
import style0 from "./tableRoleMenu.vue?vue&type=style&index=0&id=181336db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181336db",
  null
  
)

export default component.exports